<template>
  <div class="flex items-center gap-1 text-label">
    <sms-status v-if="item.status" :status="item.status" class="shrink-0" />
    <provider-image :provider="item.provider" alt="SMS Provider Icon" />
    <div
      v-if="item.is_outgoing"
      class="flex min-w-0 flex-1 items-center space-x-0-5"
    >
      <span
        v-if="item.sender?.name"
        v-tooltipable
        class="max-w-30 shrink-0 truncate"
      >
        {{ item.sender.name }}
      </span>
      <template v-if="item.receiver?.name">
        <span class="shrink-0 whitespace-nowrap">
          {{ $t("COMMON.SMS") }} {{ $t("COMMON.TO").toLowerCase() }}:
        </span>
        <span v-tooltipable class="min-w-0 truncate">
          {{ item.receiver.name }}
        </span>
      </template>
    </div>
    <div v-else class="flex min-w-0 flex-1 items-center space-x-0-5">
      <template v-if="item.sender?.name">
        <span class="shrink-0 whitespace-nowrap">{{ $t("COMMON.FROM") }}:</span>
        <span v-tooltipable class="min-w-0 truncate">
          {{ item.sender.name }}
        </span>
      </template>
    </div>
    <date-time :date="item.created_at" class="shrink-0 whitespace-nowrap" />
  </div>
</template>
<script setup lang="ts">
import ProviderImage from "@/components/communicationLogs/communication/ProviderImage.vue";
import SmsStatus from "@/components/communicationLogs/communication/sms/SmsStatus.vue";
import DateTime from "@/components/ui/ConvertibleDateTime.vue";

import type { SmsLogData } from "@/models/communicationLogs";

const { item } = defineProps<{
  item: SmsLogData;
}>();
</script>

<style scoped>
@reference "@/assets/tailwind.css";
</style>
